import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ParameterService } from '../../services/parameter/parameter.service';
import { Option } from '../../../ui-components/core-dropdown/core-dropdown.component';
import { TranslateService } from '@ngx-translate/core';
import { Dialog } from 'primeng/dialog';
import { CountryService } from '../../services/location/country.service';
import { AddressAutocompleteComponent } from '../../../ui-components/address-autocomplete/address-autocomplete.component';
import { CaseSummaryService } from './service/case-summary.service';
import {ActivatedRoute, Router} from "@angular/router";
import {MessageService} from "primeng/api";
import {AppMessageService} from "../../services/app-message/app-message.service";
import { take } from 'rxjs';
import { CallService } from '../../services/call/call.service';

@Component({
  selector: 'app-create-case-summary',
  templateUrl: './create-case-summary.component.html',
  styleUrl: './create-case-summary.component.scss'
})
export class CreateCaseSummaryComponent {
  form: FormGroup;
  isVisible: boolean = false;
  isFullScreen: boolean = false;

  caseTypeOptions: Option[] = [];
  genders: { label: string; value: string }[] = [
    { label: 'Erkek', value: 'Male' },
    { label: 'Kadın', value: 'Female' },
  ];
  countries: any[] = [];

  @ViewChild('dialog') dialog!: Dialog;
  @ViewChild('addressComponent') addressComponent!: AddressAutocompleteComponent;


  caseNo: string | null = null;
  caseTypeCode: string | null = null;
  showSuccessDialog: boolean = false;
  showNotification: boolean = false;
  patientId:null;
  constructor(
    private readonly fb: FormBuilder,
    private readonly parameterService: ParameterService,
    private readonly translate: TranslateService,
    private readonly countryService: CountryService,
    private readonly service: CaseSummaryService,
    private readonly callService: CallService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly messageService: AppMessageService
  ) {
    this.initializeForm();

    this.loadCaseTypes();
    this.loadCountries();
  }

  open() {
    this.isVisible = true;
    const defaultCase = this.caseTypeOptions.find(c => c.label.toLowerCase() === 'mobil');
    if (defaultCase) {
      this.form.get('caseType')?.setValue(defaultCase.value);
    }

    this.route.queryParams.subscribe((params) => {
      if (params['fullscreen']=='true') {
        this.isFullScreen=true;
      }
      this.form.patchValue({
        phone: params['phone'] ?? null,
        gender: params['gender'] ?? null,
        country: params['country'] ?? '+90',
        firstName: params['firstName'] ?? null,
        lastName: params['lastName'] ?? null,
        tckn: params['tckn'] ?? null,     
        age: params['age'] ?? null,     
      }, { emitEvent: false });
      this.patientId = params['patientId']
    });
  }

  close() {
    if (this.isFullScreen){
      window.close()
    }
    this.patientId = null;
    this.isVisible = false;

  }
closeAll() {
  this.showSuccessDialog = false;
  this.initializeForm();
  if (this.isFullScreen) {
    window.close(); 
  } else {
    this.close();
  }
}

  private initializeForm() {
    this.patientId = null;
    this.form = this.fb.group({
      caseType: ['', Validators.required],
      phone: [null],
      tckn: [null, [Validators.pattern(/^\d{11}$/)]],
      gender: [null],
      country: ['+90'],
      age: [null],
      firstName: [null],
      lastName: [null],
      complaint: [null],
      userNote: [null],
      addressNote: [null],
      address: [null]
    });

    this.form.get('addressNote')?.updateValueAndValidity({ emitEvent: true });

  }

  private loadCaseTypes(): void {
    this.parameterService.getParameterValues('data-group', 'caseTypes')
      .subscribe({
        next: (response) => {
          this.caseTypeOptions = response.datas.values.map((data: any) => ({
            label: data.valueObject.name.value,
            value: data.valueObject.id.value
          }));
          const defaultCase = this.caseTypeOptions.find(c => c.label.toLowerCase() === 'mobil');
          if (defaultCase) {
            this.form.get('caseType')?.setValue(defaultCase.value);
          }

        },
        error: (err) => console.error('Case types yüklenemedi:', err)
      });
  }

  private loadCountries() {
    this.countryService.getAll().subscribe((res) => {
      if (res.length > 0) {
        this.countries = res.map((item: any) => ({
          name: item.name,
          value: item.phoneCode,
          label: item.phoneCode,
          flag: item.flag
        }));
        const defaultCountry = this.countries.find(c => c?.value === '+90' || c.label === '+90');
        if (defaultCountry) {
          this.form.get('country')?.setValue(defaultCountry.value);
        }
      }
    });
  }
  openAddressModal() { this.addressComponent.openDialog(this.form.value.address); }
  openAddressDialog() {
    const currentAddress = this.form.get('address')?.value;
    this.addressComponent.openDialog(currentAddress);
  }

  onAddressDialogClose() {
    console.log('Address dialog closed');
  }

  onAddressSelected(address: any) {
    this.form.patchValue({ address });
  }

  onAddressNoteChange(ev: Event) {
    const val = (ev.target as HTMLTextAreaElement).value;
    this.form.patchValue({ addressNote: val });
  }

 save() {
  const formData = { ...this.form.value };
  if (!formData.caseType) return;

  if (this.form.valid) {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      const callCardId = params['callCardId'] ? Number(params['callCardId']) : null;
      const callId = params['callId'] ? Number(params['callId']) : null;

      const payload = {
        ...formData,
        callCardId: params['callCardId'] ? Number(params['callCardId']) : null,
        callId: params['callId'] ? Number(params['callId']) : null,
      };

      this.service.createCaseSummary(payload).subscribe({
        next: (res) => {
          if (res?.caseNo) {
            this.caseNo = res.caseNo;
            this.caseTypeCode = res.caseTypeCode;
            if (res?.caseId && callCardId) {
              this.callService.linkCaseToCallCard(callCardId, res.caseId).subscribe({
                next: () => {},
                error: (err) => console.error('Link failed', err),
              });
            }

            const hasCallParams = !!callId || !!callCardId;
            if (hasCallParams) {
              const urlTree = this.router.createUrlTree(
                ['/case', res?.caseId],
                {
                  queryParams: {
                    openSidebar: true,
                    fullscreen: true,
                    patientId: Number(this.patientId),
                  }
                }
              );

              const url = this.router.serializeUrl(urlTree);
              window.open(url, '_blank');
              this.isVisible = false;
              window.close();
              return;
            }

            this.showSuccessDialog = true;

            this.messageService.successToast(
              this.translate.instant('common.success'),
              this.translate.instant('definition.case-features.create.create-success')
            );
          }
        },
        error: (err) => console.error('Vaka kaydedilemedi', err)
      });
    });
  } else {
    this.form.markAllAsTouched();
  }
}


 copyText() {
  const textToCopy = `${this.caseTypeCode}-${this.caseNo}`;

  navigator.clipboard.writeText(textToCopy).then(() => {
    this.showNotification = true;

    setTimeout(() => {
      this.showNotification = false;

      this.showSuccessDialog = false;
      this.isVisible = false;

      window.close();
    }, 800);
  });
}

  isInvalid(name: string, errorKey?: string) {
    const c = this.form.get(name);
    if (!c) return false;

    const show = c.touched ?? c.dirty;
    if (!show) return false;

    return errorKey ? c.hasError(errorKey) : c.invalid;
  }
  onlyDigit(event: KeyboardEvent): boolean {
    const key = event.key;

    if (!/^\d$/.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

}
